const siteUrl = "https://www.jetblackairport-luxury.com";
const brandName = "Jet Black Limousine";
const alternateBrandName = "Jet Black Luxury";
const phone = "+19149628444";
const displayPhone = "(914) 962-8444";
const defaultImage = `${siteUrl}/favicon.svg`;

const geoAreaServed = [
  "Yorktown Heights",
  "Yorktown",
  "Westchester County",
  "Bedford",
  "Scarsdale",
  "White Plains",
  "Westchester County Airport",
  "HPN",
  "JFK Airport",
  "John F. Kennedy International Airport",
  "JFK",
  "LaGuardia Airport",
  "LGA",
  "Newark Liberty International Airport",
  "EWR",
  "Manhattan",
  "Queens",
  "Bronx",
  "Brooklyn",
  "New York City",
  "NYC",
  "Stewart International Airport",
  "SWF",
];

const primaryAreaServed = [
  "Yorktown Heights",
  "Yorktown",
  "Westchester County",
  "Bedford",
  "Scarsdale",
  "White Plains",
  "Westchester County Airport",
  "HPN",
  "JFK Airport",
  "LGA",
  "EWR",
];

const secondaryAreaServed = [
  "Manhattan",
  "Queens",
  "Bronx",
  "Brooklyn",
  "New York City",
  "NYC",
];

const airportServiceTypes = [
  "Yorktown Heights airport car service",
  "Westchester County airport car service",
  "HPN airport car service",
  "JFK airport car service",
  "LGA airport car service",
  "EWR airport car service",
  "black car service",
  "black SUV service",
  "airport transportation",
  "corporate transportation",
  "private chauffeur service",
];

const contactPoint = {
  "@type": "ContactPoint",
  telephone: phone,
  contactType: "reservations",
  areaServed: geoAreaServed,
  availableLanguage: ["en"],
  url: `${siteUrl}/contact`,
};

const localBusiness = {
  "@type": "LocalBusiness",
  "@id": `${siteUrl}/#localbusiness`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  telephone: phone,
  priceRange: "$$",
  image: defaultImage,
  address: {
    "@type": "PostalAddress",
    streetAddress: "395 Hallocks Mill Rd",
    addressLocality: "Yorktown Heights",
    addressRegion: "NY",
    postalCode: "10598",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 41.2706,
    longitude: -73.7777,
  },
  areaServed: geoAreaServed,
  contactPoint,
  sameAs: [
    "https://reviews.birdeye.com/jet-black-limousine-170834567544871",
    "https://www.bbb.org/us/ny/yorktown-heights/profile/transportation/jet-black-limousine-0121-87164747",
  ],
};

const organization = {
  "@type": "Organization",
  "@id": `${siteUrl}/#organization`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  telephone: phone,
  logo: defaultImage,
  contactPoint,
  sameAs: localBusiness.sameAs,
};

const website = {
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  name: brandName,
  alternateName: alternateBrandName,
  url: `${siteUrl}/`,
  publisher: { "@id": `${siteUrl}/#organization` },
};

const makeOffer = ({ name, description, url = `${siteUrl}/booking`, areaServed = primaryAreaServed }) => ({
  "@type": "Offer",
  name,
  description,
  areaServed,
  url,
});

const airportOfferCatalog = {
  "@type": "OfferCatalog",
  "@id": `${siteUrl}/#airport-offers`,
  name: "Yorktown Heights and Westchester Airport Car Service Offers",
  itemListElement: [
    makeOffer({
      name: "Yorktown Heights to HPN Airport Car Service",
      description: "Private black car and SUV airport transportation from Yorktown Heights and Westchester County to Westchester County Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to JFK Airport Car Service",
      description: "Reserved chauffeur service from Yorktown Heights and Westchester County to John F. Kennedy International Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to LGA Airport Car Service",
      description: "Private airport car service from Yorktown Heights and Westchester County to LaGuardia Airport.",
    }),
    makeOffer({
      name: "Yorktown Heights to EWR Airport Car Service",
      description: "Black car and SUV transportation from Yorktown Heights and Westchester County to Newark Liberty International Airport.",
    }),
    makeOffer({
      name: "Westchester County Corporate Airport Transportation",
      description: "Corporate chauffeur service for Westchester County travelers to HPN, JFK, LGA and EWR.",
    }),
  ],
};

const faq = {
  "@type": "FAQPage",
  "@id": `${siteUrl}/#faq`,
  mainEntity: [
    {
      "@type": "Question",
      name: "Does Jet Black Limousine provide airport car service from Yorktown Heights?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Jet Black Limousine provides private airport car service from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR.",
      },
    },
    {
      "@type": "Question",
      name: "Which airport is closest to Yorktown Heights?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Westchester County Airport, also known as HPN, is the closest major airport served by Jet Black Limousine from Yorktown Heights.",
      },
    },
    {
      "@type": "Question",
      name: "Can I book Westchester County car service to JFK, LGA or EWR?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Jet Black Limousine accepts reservations for Westchester County airport transportation to JFK, LaGuardia and Newark Liberty.",
      },
    },
    {
      "@type": "Question",
      name: "Is airport transportation available 24/7?",
      acceptedAnswer: {
        "@type": "Answer",
        text: `Yes. Jet Black Limousine supports airport transportation reservations 24/7. Call ${displayPhone} or book online.`,
      },
    },
  ],
};

export const homeSeo = {
  id: "home",
  title: "Jet Black Limousine | Private Car Service in Westchester",
  description: `Jet Black Limousine provides private car service in Westchester for airport transportation, black SUV service, corporate travel and private chauffeur reservations. Call ${displayPhone}.`,
  keywords: "Yorktown Heights airport car service, Westchester County airport car service, Bedford car service, Scarsdale car service, White Plains car service, black car service NYC, HPN airport car service, JFK airport car service, LGA airport car service, EWR airport car service, black SUV service, private chauffeur Westchester County, Jet Black Limousine",
  canonical: `${siteUrl}/`,
  robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  areaServed: geoAreaServed,
  openGraph: {
    title: "Jet Black Limousine | Private Car Service in Westchester",
    description: `Jet Black Limousine provides private car service in Westchester for airport transportation, black SUV service, corporate travel and private chauffeur reservations. Call ${displayPhone}.`,
    url: `${siteUrl}/`,
    type: "website",
    image: defaultImage,
    siteName: brandName,
    locale: "en_US",
  },
  twitter: {
    card: "summary_large_image",
    title: "Jet Black Limousine | Private Car Service in Westchester",
    description: `Jet Black Limousine provides private car service in Westchester for airport transportation, black SUV service, corporate travel and private chauffeur reservations. Call ${displayPhone}.`,
    url: `${siteUrl}/`,
    image: defaultImage,
  },
  jsonLd: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        url: `${siteUrl}/`,
        name: "Jet Black Limousine Private Car Service in Westchester",
        headline: "Private Car Service in Westchester",
        description: "Private car service in Westchester with airport transportation, black SUV service, corporate travel and private chauffeur reservations from Jet Black Limousine.",
        isPartOf: { "@id": `${siteUrl}/#website` },
        about: { "@id": `${siteUrl}/#airport-car-service` },
        breadcrumb: { "@id": `${siteUrl}/#breadcrumb` },
        potentialAction: [
          { "@type": "ReserveAction", name: "Book Yorktown Heights airport car service", target: `${siteUrl}/booking` },
          { "@type": "CommunicateAction", name: "Call Jet Black Limousine in Yorktown Heights", target: `tel:${phone}` },
        ],
      },
      localBusiness,
      organization,
      website,
      {
        "@type": "Service",
        "@id": `${siteUrl}/#airport-car-service`,
        name: "Yorktown Heights and Westchester Airport Car Service",
        alternateName: "Westchester County black car and airport transportation",
        description: "Westchester airport car service, black SUV service, corporate transportation and private chauffeur service from Yorktown Heights, Bedford, Scarsdale and White Plains to HPN, JFK, LGA and EWR, with Manhattan, Queens, Bronx and Brooklyn served as secondary NYC markets.",
        provider: { "@id": `${siteUrl}/#localbusiness` },
        serviceType: airportServiceTypes,
        areaServed: [...primaryAreaServed, ...secondaryAreaServed],
        url: `${siteUrl}/`,
        hasOfferCatalog: { "@id": `${siteUrl}/#airport-offers` },
        offers: makeOffer({
          name: "Book Yorktown Heights Airport Car Service",
          description: "Reserve private airport transportation from Yorktown Heights and Westchester County to HPN, JFK, LGA and EWR.",
        }),
      },
      airportOfferCatalog,
      faq,
      {
        "@type": "BreadcrumbList",
        "@id": `${siteUrl}/#breadcrumb`,
        itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: `${siteUrl}/` }],
      },
    ],
  },
};
